import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/general/banner01@3x.png';
import _imports_1 from '@/assets/images/general/wave@3x.png';
import _imports_2 from '@/assets/images/logo/civil-logo.svg';

var _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "logo-area"
}, [/*#__PURE__*/_createVNode("img", {
  class: "area-main-img",
  src: _imports_0,
  alt: "",
  srcset: ""
}), /*#__PURE__*/_createVNode("img", {
  class: "area-wave",
  src: _imports_1,
  alt: "",
  srcset: ""
}), /*#__PURE__*/_createVNode("img", {
  class: "area-logo",
  src: _imports_2,
  alt: "logo"
})], -1);

var _hoisted_2 = {
  class: "page-inner page-inner-30px"
};

var _hoisted_3 = /*#__PURE__*/_createVNode("h2", {
  class: "section-lg-title"
}, "會員登入", -1);

var _hoisted_4 = {
  class: "common-link-bar"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("忘記密碼？");

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" 登入 ");

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 會員註冊 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_f7_nav_left = _resolveComponent("f7-nav-left");

  var _component_f7_nav_title = _resolveComponent("f7-nav-title");

  var _component_f7_link = _resolveComponent("f7-link");

  var _component_f7_nav_right = _resolveComponent("f7-nav-right");

  var _component_f7_navbar = _resolveComponent("f7-navbar");

  var _component_BaseInput = _resolveComponent("BaseInput");

  var _component_f7_button = _resolveComponent("f7-button");

  var _component_BaseSpacer = _resolveComponent("BaseSpacer");

  var _component_f7_page = _resolveComponent("f7-page");

  return _openBlock(), _createBlock(_component_f7_page, {
    name: "login",
    class: "sty-page-bottom-veg-deco2",
    "no-toolbar": "",
    "no-navbar": ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_f7_navbar, {
        noShadow: "",
        noHairline: "",
        class: "navbar-index navbar-no-bg-always",
        transparent: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_f7_nav_left), _createVNode(_component_f7_nav_title), _createVNode(_component_f7_nav_right, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_link, {
                class: "btn-envelope"
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode("div", null, [_hoisted_1, _createVNode("form", {
        class: "form-list",
        onSubmit: _cache[4] || (_cache[4] = function () {
          return $setup.onFormSubmit && $setup.onFormSubmit.apply($setup, arguments);
        })
      }, [_createVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_BaseInput, {
        sty: "bar",
        labelName: "會員帳號",
        name: "account",
        inputmode: "tel",
        type: "text",
        placeholder: "請輸入手機號碼",
        icon: "icon-phone_call",
        modelValue: $setup.values.account,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return $setup.values.account = $event;
        }),
        modelModifiers: {
          trim: true
        },
        h: "45px"
      }, null, 8, ["modelValue"]), _createVNode(_component_BaseInput, {
        sty: "bar password",
        labelName: "會員密碼",
        class: "mb-10px!",
        name: "password",
        type: "password",
        placeholder: "請輸入密碼",
        icon: "icon-lock",
        modelValue: $setup.values.password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return $setup.values.password = $event;
        }),
        h: "45px"
      }, null, 8, ["modelValue"]), _createVNode("div", _hoisted_4, [_createVNode(_component_f7_link, {
        class: "text-gray",
        href: "/forgot_pwd"
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      })]), _createVNode(_component_f7_button, {
        type: "submit",
        disabled: $setup.cData.btnDisabled,
        class: "btn-theme btn-radius-10px btn-lt-space size-h-45px mb-20px text-bold"
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_f7_button, {
        type: "button",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.$window._direct_page('/register_step1');
        }),
        disabled: $setup.cData.btnDisabled,
        class: "btn btn-outline-light btn-radius-10px btn-lt-space size-h-45px text-bold"
      }, {
        default: _withCtx(function () {
          return [_hoisted_7];
        }),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_BaseSpacer, {
        h: "15px"
      })])], 32)])];
    }),
    _: 1
  });
}